import { Settings } from '@streamr/tv-engine/~/settings';
import { wrap } from 'comlink';
import { Track } from './Track';
/**
 * Fallback audio decoder for browsers where WebCodecs AudioDecoder does not
 * truly support Opus (e.g. Safari). Uses the @streamr/opus WASM library via
 * a dedicated Web Worker (OpusWorker) to decode Opus frames.
 */
export class OpusAudioDecoder {
    LOG_PREFIX = '[OpusAudioDecoder]';
    worker;
    workerApi;
    unencodedOutputTrack;
    done = false;
    decodedFrameCount = 0;
    constructor(trackId, _codec = Settings.audioCodec) {
        this.unencodedOutputTrack = new Track(trackId, false);
        console.log(`${this.LOG_PREFIX} constructor called`, { trackId });
    }
    async init(_errorListener) {
        console.log(`${this.LOG_PREFIX} init called`);
        this.worker = new Worker(new URL('./OpusWorker.ts', import.meta.url), {
            type: 'module',
        });
        this.workerApi = wrap(this.worker);
        console.log(`${this.LOG_PREFIX} init completed`);
    }
    feedEncodedAudioFrame(frame) {
        if (frame.done) {
            console.log(`${this.LOG_PREFIX} done frame received`);
            this.shutdown().catch(console.error);
            return;
        }
        if (this.done) {
            console.warn(`${this.LOG_PREFIX} is done, cannot feed more frames`);
            return;
        }
        if (!this.workerApi) {
            return;
        }
        this.workerApi
            .decodeAudioFrame(frame)
            .then((unencodedAudioFrame) => {
            this.decodedFrameCount++;
            this.unencodedOutputTrack.emit(unencodedAudioFrame, false, [
                unencodedAudioFrame.data.buffer,
            ]);
        })
            .catch((error) => {
            console.error(`${this.LOG_PREFIX} decode error:`, error);
        });
    }
    getUnencodedOutputTrack() {
        return this.unencodedOutputTrack;
    }
    async destroy() {
        console.log(`${this.LOG_PREFIX} destroy called`);
        if (this.done)
            return;
        this.done = true;
        if (this.workerApi) {
            await this.workerApi.dispose().catch(() => { });
            this.workerApi = undefined;
        }
        if (this.worker) {
            this.worker.terminate();
            this.worker = undefined;
        }
    }
    async shutdown() {
        console.log(`${this.LOG_PREFIX} shutdown called`, {
            totalDecodedFrames: this.decodedFrameCount,
        });
        await this.destroy();
        this.unencodedOutputTrack.emit(undefined, true);
        console.log(`${this.LOG_PREFIX} shutdown completed`);
    }
}
